<template>
  <fb-default-layout :sidebar-data="sidebarData" routeViewType="route"></fb-default-layout>
</template>

<script>
  import menu from "../js/menu";

export default {
  name: "Index",
  components: {},
  data() {
    return {
      sidebarData: menu
    }
  },
  methods: {},
  watch: {}
}
</script>

<style lang="scss" scoped>

</style>
